export default __webpack_public_path__ + "static/media/MM5D.3f109d0e.jpg";